// src/components/widgets/SafetyStatusStrip.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listSafetyChecklists } from "../../api/safety";
import WidgetCard from "./WidgetCard";

/**
 * 안전 신호등 요약 위젯 (Compact Version for Dashboard)
 */
function SafetyStatusStrip({ projectId: propProjectId }) {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({
    actionNeeded: 0,
    inProgress: 0,
    done: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const projectId =
    propProjectId ||
    localStorage.getItem("projectId") ||
    localStorage.getItem("projectCode") ||
    "";

  const handleClick = (status) => {
    navigate(`/project/${projectId}/safety/board/all?progress=${status}`);
  };

  useEffect(() => {
    const fetch = async () => {
      if (!projectId) return;
      try {
        setLoading(true);
        setError("");

        const res = await listSafetyChecklists({ project: projectId });
        const raw = res?.results || res?.data?.results || res || [];
        const list = Array.isArray(raw) ? raw : [];

        let actionNeeded = 0;
        let inProgress = 0;
        let done = 0;

        list.forEach((row) => {
          const p = String(row.progress || "").toLowerCase();

          if (p === "completed") {
            done += 1;
          } else if (
            p === "action_needed" ||
            p === "urgent" ||
            p === "failed"
          ) {
            actionNeeded += 1;
          } else if (p === "in_progress" || p === "planned") {
            inProgress += 1;
          }
        });

        setCounts({ actionNeeded, inProgress, done });
      } catch (e) {
        console.error("안전 신호등 집계 실패:", e);
        setError("데이터를 불러오지 못했습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, [projectId]);

  return (
    <WidgetCard title="안전 신호등" className="shadow-sm border-gray-100 h-full"> 
      {error ? (
        <p className="text-xs text-rose-500">{error}</p>
      ) : (
        <div className="flex justify-between items-center h-full px-1">
          {/* 조치 필요 */}
          <button
            onClick={() => handleClick("action_needed")}
            className="flex flex-col items-center gap-1 group"
            title="조치 필요"
          >
            <div className="w-8 h-8 rounded-full bg-rose-500/10 text-rose-600 flex items-center justify-center border border-rose-100 group-hover:bg-rose-500 group-hover:text-white transition-all">
              <span className="font-bold text-sm">{counts.actionNeeded}</span>
            </div>
            <span className="text-[10px] text-gray-500 group-hover:text-rose-600">조치</span>
          </button>

          <div className="w-px h-6 bg-gray-100" />

          {/* 진행 중 */}
          <button
            onClick={() => handleClick("in_progress")}
            className="flex flex-col items-center gap-1 group"
            title="진행 중"
          >
            <div className="w-8 h-8 rounded-full bg-amber-400/10 text-amber-600 flex items-center justify-center border border-amber-100 group-hover:bg-amber-400 group-hover:text-white transition-all">
              <span className="font-bold text-sm">{counts.inProgress}</span>
            </div>
            <span className="text-[10px] text-gray-500 group-hover:text-amber-600">진행</span>
          </button>

          <div className="w-px h-6 bg-gray-100" />

          {/* 완료 */}
          <button
            onClick={() => handleClick("completed")}
            className="flex flex-col items-center gap-1 group"
            title="완료"
          >
            <div className="w-8 h-8 rounded-full bg-green-500/10 text-green-600 flex items-center justify-center border border-green-100 group-hover:bg-green-500 group-hover:text-white transition-all">
              <span className="font-bold text-sm">{counts.done}</span>
            </div>
            <span className="text-[10px] text-gray-500 group-hover:text-green-600">완료</span>
          </button>
        </div>
      )}
    </WidgetCard>
  );
}

export default SafetyStatusStrip;
